//
// Module for the Index view
//
rs.module("ui/content/jobs/insuranceimport/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(backendUrls, gridLrsApi, batchProcessing) {
            // Only implement refreshing of grid if batch is processing
            if (batchProcessing) {
                const batchProcessingTimeout = 1000;
                const normalTimeout = 10000;

                // Initialize the refresh timer when the page first displays. If a batch was just processed,
                // refresh the grid in 1 second to check on the status. Else, refresh after 10 seconds.  
                var refreshTimer = setupTimer(batchProcessing ? batchProcessingTimeout : normalTimeout);

                //
                // Setup refresh timer for delayed grid refresh
                //
                function setupTimer(timeout) {
                    return setTimeout(refreshBatchesGrid, timeout);
                }

                //
                // Refresh the Batches grid
                //
                function refreshBatchesGrid() {

                    // Reset the refresh timer
                    clearTimeout(refreshTimer);

                    gridModule.update(
                        backendUrls.getBatches,
                        {},
                        gridLrsApi.agGridApi,
                        function done() {
                        }
                    )
                        .always(function () {
                            _refreshTimer();
                        });
                }

                //
                // Refresh the Timer if needed
                //
                function _refreshTimer() {

                    // Retrieve if there is a batch still processing
                    $.get(
                        backendUrls.getBatchProcessing,
                        {}
                    )
                        .done(function (results) {
                            if (results.batchProcessing) {
                                // Setup a new refresh timer to run in 10 seconds to check again for updated batches
                                refreshTimer = setupTimer(normalTimeout);
                            }
                        });
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);